// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--22bf2","title":"a10a3f92e9--title--3Q7_w","text":"a10a3f92e9--text--DvXfv"};